import styled from "@emotion/styled";
import React from "react";

type BannerVariant = "info" | "warning";

const Banner = styled.div<{ variant: BannerVariant }>`
  padding: 16px 24px;
  border-radius: 8px;
  margin-bottom: 24px;
  background-color: ${({ theme, variant }) =>
    variant === "info" ? theme.colors.forest : theme.colors.buttercup};
  color: ${({ theme, variant }) =>
    variant === "info" ? theme.colors.snowdrop : theme.colors.charcoal};
  text-align: center;
  font-size: 16px;
  line-height: 1.5;
`;

const Username = styled.span`
  font-weight: 700;
`;

export type ChildProfileBannerProps = {
  parentUsername: string;
  parentExists: boolean;
};

export const ChildProfileBanner = ({
  parentUsername,
  parentExists,
}: ChildProfileBannerProps) => {
  if (parentExists) {
    return (
      <Banner variant="info">
        Your new account will be created within{" "}
        <Username>{parentUsername}</Username>
      </Banner>
    );
  }

  return (
    <Banner variant="warning">
      You are attempting to create a profile within{" "}
      <Username>{parentUsername}</Username>, which does not exist
    </Banner>
  );
};
